// extracted by mini-css-extract-plugin
export default {"container":"styles_container__JtvgJ","header":"styles_header__zCk0R","content":"styles_content__B8xQB"};